import React, { useEffect, useState } from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import { useSelector } from "react-redux";
import ResponsiveDrawer from '../components/ResponsiveDrawer';
import CircularLoading from "../components/CircularLoading";
import { getUserRole, hasPermission } from '../common/permissionUtils';

function matchUser(permit, usertype){
    let permitions = permit? permit.split(',') : [];
    let permitted = false;
    for(let i=0;i<permitions.length;i++){
        permitted = usertype === permitions[i]?true:false
        if(permitted) break;
    }
    return permitted;
}

function ProtectedRoute({ permit, requiredPermission, children }) {
    const auth = useSelector(state => state.auth);
    const settings = useSelector(state => state.settingsdata.settings);
    const [checkedAuth,setCheckedAuth] = useState(false);
    const location = useLocation();

    useEffect(()=>{
        if(auth.profile && auth.profile.uid){
            setCheckedAuth(true);
        }
        if(auth.error && auth.error.msg && !auth.profile){
            setCheckedAuth(true);
        }
    },[auth.profile,auth.error])

    const role = getUserRole(auth.profile);
    const permitOk = permit ? matchUser(permit, auth.profile?.usertype) || matchUser(permit, role) : true;
    const permissionOk = requiredPermission
        ? hasPermission(auth.profile, settings, requiredPermission.module, requiredPermission.action)
        : true;

    return(
        checkedAuth?
            auth.profile && auth.profile.uid?
                permitOk && permissionOk ? <ResponsiveDrawer>{children}</ResponsiveDrawer>:<Navigate to="/login" state={{ from: location.pathname + location.search }} />
            :<Navigate to="/login" state={{ from: location.pathname + location.search }} /> 
        :<CircularLoading/>
    )
}

export default ProtectedRoute;
